export const user = {
  tableCol: {
    no: { en: 'No.', ko: '번호', fr: '' },
    organization: { en: 'Organization', ko: '조직', fr: '' },
    firstName: { en: 'First name', ko: '이름', fr: '' },
    lastName: { en: 'Last name', ko: '성', fr: '' },
    email: { en: 'Email', ko: '이메일', fr: '' },
    id: { en: 'ID', ko: 'ID', fr: '' },
    name: { en: 'Name', ko: '이름', fr: '' },
  },
  info: {
    name: { en: 'Name', ko: '이름', fr: '' },
    firstName: { en: 'First name', ko: '이름', fr: '' },
    lastName: { en: 'Last name', ko: '성', fr: '' },
    status: { en: 'Status', ko: '상태', fr: '' },
    passwordEdit: { en: 'Password change', ko: '비밀번호 재설정', fr: '' },
    password: { en: 'Password', ko: '비밀번호', fr: '' },
    timezone: { en: 'Timezone', ko: '시간대', fr: '' },
    type: { en: 'Type', ko: '유형', fr: '' },
    email: { en: 'Email', ko: '이메일', fr: '' },
    role: { en: 'Role', ko: '권한', fr: '' },
    roleEdit: { en: 'Role management', ko: '권한 관리', fr: '' },
    category: { en: 'Category', ko: '카테고리', fr: '' },
    registerDate: { en: 'Register date', ko: '등록날짜', fr: '' },
    updateDate: { en: 'Update date', ko: '수정날짜', fr: '' },
    organizationList: { en: 'Organization list', ko: '조직 목록', fr: '' },
    organization: { en: 'Organization', ko: '조직', fr: '' },
    organizationRegistration: { en: 'Organization registration', ko: '조직 등록', fr: '' },
    region: { en: 'Country', ko: '국가', fr: '' },
    city: { en: 'City', ko: '도시', fr: '' },
    default_inital_page: { en: 'Initial page', ko: '초기 화면', fr: '' },
    distributor: { en: 'Distributor', ko: '대리점', fr: '' },
    user_id: { en: 'User ID', ko: '아이디', fr: '' },
    phoneNumber: { en: 'Phone number', ko: '전화번호', fr: '' },
  },
  passwordEdit: {
    currentPassword: { en: 'Current password', ko: '현재 비밀번호', fr: '' },
    newPassword: { en: 'New password', ko: '새 비밀번호', fr: '' },
    passwordCheck: { en: 'Password confirm', ko: '비밀번호 확인', fr: '' },
  },
  drawer: {
    passwordEdit: { en: 'Password edit', ko: '비밀번호 재설정', fr: '' },
    userRoleEdit: { en: 'User Role Management', ko: '사용자 권한 관리', fr: '' },
    companyRoleCreate: { en: 'Organization role create', ko: '조직 권한 추가', fr: '' },
    organizationPrivCreate: { en: 'Organization Privilege', ko: '조직 권한 추가', fr: '' },
  },
  select: {
    organization: { en: 'Organization', ko: '조직 선택', fr: '' },
  },
  profile: { en: 'Profile', ko: '프로필', fr: '' },
};
